import { createReducer, on } from '@ngrx/store';
import * as pageActions from '../actions/faq-category.action';
import { ToEntities } from '@teamfoster/sdk/array-utility';
import { FaqCategory } from '../../models';

export interface FaqCategoriesState {
  entities: { [id: string]: FaqCategory };
  loaded: boolean;
  loading: boolean;
  error?: any;
}

export const initialState: FaqCategoriesState = {
  entities: {},
  loaded: false,
  loading: false,
};

export const FaqCategoriesReducer = createReducer(
  initialState,
  on(pageActions.LoadFaqCategories, (state: FaqCategoriesState) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(pageActions.LoadFaqCategoriesSuccess, (state: FaqCategoriesState, { categories }) => {
    const entities = ToEntities(categories, 'id', state.entities);
    return {
      ...state,
      entities,
      loading: false,
      loaded: true,
    };
  }),
  on(pageActions.LoadFaqCategoriesFail, (state: FaqCategoriesState, { error }) => {
    return {
      ...state,
      overviewLoading: false,
      overviewLoaded: false,
      error,
    };
  }),
  on(pageActions.ClearFaqCategories, (state: FaqCategoriesState) => {
    return {
      ...initialState,
    };
  })
);

export const getFaqCategoriesEntities = (state: FaqCategoriesState) => state.entities;
export const getFaqCategoriesLoading = (state: FaqCategoriesState) => state.loading;
export const getFaqCategoriesLoaded = (state: FaqCategoriesState) => state.loaded;
